import { Col, Row } from "antd";
import React, { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import { useTranslation } from "react-i18next";
import { COURSE_REPORT_URL } from "../../api/URLs";
import { getDataRequest } from "../../api/serviceMethods";
import { BsArrowUpRightSquareFill } from "react-icons/bs";
import { useLocation } from "react-router-dom";

const DashboardCourseComponent = (props, ref) => {
    const { t } = useTranslation();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const teacherId = queryParams.get("id");
    const [dashboardMemberData, setDashboardMemberData] = useState(null);
    const getDashboard = async () => {
        try {
            const res = await getDataRequest(`${COURSE_REPORT_URL}`, {
                teacherId: teacherId
            });
            if (res.status === 200) {
                setDashboardMemberData(res.data);
            }
        } catch (error) {
            console.error("Error fetching dashboard data:", error);
        }
    };

    useEffect(() => {
        getDashboard();
    }, [])
    const dashboardData = [
        {
            title: "",
            total: (
                <div className="d-flex align-items-center">
                    <img style={{ width: "72px", height: "96px", borderRadius: "6px", objectFit: "cover" }} src={dashboardMemberData && dashboardMemberData?.teacher?.picUrl} />
                    <div className="ml-3" style={{ fontSize: "1rem", marginLeft: "1rem" }}>{dashboardMemberData && dashboardMemberData?.teacher?.name}</div>
                </div>
            ),
            rate: ""
        },
        {
            title: t("Number of courses"),
            total: dashboardMemberData && dashboardMemberData?.courseCount,
            rate: ""
        },
        {
            title: t("Course purchase amount"),
            total: (
                <div>
                    <span>{dashboardMemberData && dashboardMemberData?.purchaseAmounts}</span>
                    {/* <BsArrowUpRightSquareFill size={16} color="#45b887" style={{marginLeft:"0.5rem"}}/>
                    <span style={{fontSize:"1rem", color:"#636E88", marginLeft:"0.5rem"}}>{dashboardMemberData && dashboardMemberData.proRate + "%"}</span> */}
                </div>
            ),
            rate: ""
        }
    ]
    useImperativeHandle(ref, () => {
        return { getDashboard: getDashboard }
    })

    return (
        <Row >
            {
                dashboardData.map((item, ind) => (
                    <Col xs={24} sm={12} md={6} lg={6}>
                        <div className="d-flex" style={{ padding: "1.5rem 3rem", justifyContent: "space-between" }}>
                            <Row
                                className="text-center"
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    // justifyContent: "center",
                                    alignItems: "flex-start"
                                }}
                            >
                                <Col className="titleCardNew14400">{item.title}</Col>
                                <Col className="totalCard28500">{item.total}</Col>
                            </Row>
                            {
                                item.title === "Course purchase amount" || item.title === "课程购买金额" ? "" :
                                    <div className="vr" style={{ height: "80px", borderLeft: "1px solid #000" }}></div>
                            }
                        </div>
                    </Col>
                ))
            }
        </Row>
    );
};

export default forwardRef(DashboardCourseComponent);
